import type { Components } from '@mui/material/styles/components';
import type { Theme } from '@mui/material/styles/createTheme';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-focused': {
        backgroundColor: 'transparent',
        borderColor: theme.palette.primary.main,
      },
    }),
    icon: () => ({
      right: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      '&.Mui-disabled': {
        color: '#939DB8',
      },
    }),
    iconOpen: {
      transform: 'rotate(180deg)  translateY(50%)',
    },
  },
};
